<template>
  <v-slide-x-transition appear mode="out-in">
    <div v-if="user && user.id > 0">
      <setup-guide-view v-if="!isFirstSetupDone"></setup-guide-view>
      <account-subscription-expired-component @logout="logoutUser"
                                              v-else-if="user.accountSubscription && user.accountSubscription.expired"
                                              :account-subscription="user.accountSubscription"></account-subscription-expired-component>
      <div v-else>
        <tour-component></tour-component>
        <v-navigation-drawer
            id="navDrawer"
            v-model="drawer"
            :src="require('../../assets/mountains.jpg')"
            absolute
            app
            class="navdrawer-background elevation-1"
            clipped
            height="100%"
        >
          <v-list dense>
            <v-list>
              <v-tooltip bottom nudge-top="25" open-delay="1550">
                <template v-slot:activator="{ on }">
                                    <span v-on="on">
                                        <v-list-item id="avatar" two-line
                                                     @click="$router.push({name: 'adminUseraccount'})">
                                            <v-list-item-avatar>
                                              <initials-avatar-component
                                                  :imgSrc="userAvatar"
                                                  :size="32"
                                                  :firstname="user.firstname"
                                                  :lastname="user.lastname"
                                              ></initials-avatar-component>
                                            </v-list-item-avatar>
                                            <v-list-item-content>
                                                <v-list-item-title>{{
                                                    user.firstname + ' ' + user.lastname
                                                  }}</v-list-item-title>
                                                <v-list-item-subtitle>{{
                                                    user.applicationEmailAddress
                                                  }}</v-list-item-subtitle>
                                                <v-list-item-subtitle v-if="user.accountSubscription"><v-btn block
                                                                                                             class="py-3"
                                                                                                             disabled
                                                                                                             outlined
                                                                                                             x-small>{{
                                                    subscriptionName
                                                  }}</v-btn></v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </span>
                </template>
                <span>
                                    {{ user.applicationEmailAddress }}
                                </span>
              </v-tooltip>
            </v-list>
            <v-divider></v-divider>
            <v-list-item-group color="primary">
              <v-list-item :data-cy="item.dataCy" v-for="item in navItems" :key="item.text" :to="item.to">
                <v-list-item-icon>
                  <v-slide-x-transition mode="out-in">
                    <v-avatar v-if="item.badge" :color="item.badge.color" height="23px"
                              min-width="22px"
                              width="23px"><span
                        class="white--text subtitle-2">{{ item.badge.text }}</span>
                    </v-avatar>
                    <v-icon v-else>{{ item.icon }}</v-icon>
                  </v-slide-x-transition>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.text }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-subheader>Mitt konto</v-subheader>
              <v-list-item data-cy="navCalendarSubscription" :to="{name: 'adminCalendarSubscription'}">
                <v-list-item-icon>
                  <v-icon>mdi-calendar-repeat-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Kalenderprenumerationer</v-list-item-title>
              </v-list-item>
              <v-list-item data-cy="navAdminEmailContent" :to="{name: 'adminEmailContent'}">
                <v-list-item-icon>
                  <v-icon>mdi-email-edit-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>E-postinnehåll</v-list-item-title>
              </v-list-item>
              <v-list-item data-cy="navAdminDynamicDocuments" :to="{name: 'dynamicDocuments'}">
                <v-list-item-icon>
                  <v-icon>mdi-file-document-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Dynamiska dokument</v-list-item-title>
              </v-list-item>
              <v-list-item data-cy="navAdminUserAccount" :to="{name: 'adminUseraccount'}">
                <v-list-item-icon>
                  <v-icon>mdi-settings-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Kontoinställningar
                  <!-- TODO show alert-icon if subscription is close to ending --></v-list-item-title>
              </v-list-item>
              <div v-if="user.systemAdmin === 1">
                <v-subheader class="mt-3 grey--text text--darken-1">Systemadministration</v-subheader>
                <v-list-item :to="{name: 'adminAttributes'}" class="mt-1">
                  <v-list-item-icon>
                    <v-icon>mdi-label-percent-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Attribut</v-list-item-title>
                </v-list-item>
                <v-list-item to="/systemadministration/presentationsmallar">
                  <v-list-item-icon>
                    <v-icon>web</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Presentationsmallar</v-list-item-title>
                </v-list-item>
                <v-list-item :value="editTour" @click="$store.commit('setEditTour', !editTour)">
                  <v-list-item-icon>
                    <v-icon>mdi-teach</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Guidad genomgång</v-list-item-title>
                </v-list-item>
              </div>
              <v-divider class="mt-5"></v-divider>
              <v-list-item class="mt-2 mb-2" @click="logoutUser">
                <v-list-item-icon>
                  <v-icon>power_settings_new</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Logga ut</v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-navigation-drawer>
        <v-app-bar
            app
            clipped-left
            color="primary"
            dark
            dense
            fixed
        >
          <v-app-bar-nav-icon @click.stop="drawer = !drawer">
            <v-icon>{{ drawer ? 'menu_open' : 'menu' }}</v-icon>
          </v-app-bar-nav-icon>
          <v-toolbar-title class="pl-3 pl-sm-6 pr-8 pt-1">
            <router-link :to="{name: 'home'}">
              <logo-component :height="logoSize" :width="logoSize" color="white"></logo-component>
            </router-link>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-layout align-center row style="max-width: 650px">
            <global-search-component></global-search-component>
          </v-layout>
          <v-fade-transition appear>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                                <span v-on="on">
                                    <v-menu offset-y transition="slide-y-transition">
                                        <template v-slot:activator="{ on }">
                                            <v-btn v-on="on"
                                                   class="ml-7 mr-3" icon small>
                                                <v-icon color="white">mdi-help-circle-outline</v-icon>
                                            </v-btn>
                                        </template>
                                        <support-menu-component :show-tour-btn="showTourBtn"
                                                                @startTour="startTour"></support-menu-component>
                                    </v-menu>
                                </span>
              </template>
              <span>Hjälp</span>
            </v-tooltip>
          </v-fade-transition>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                            <span
                                id="headwayChangelog"
                                v-on="on"></span>
            </template>
            <span>Nyheter och uppdateringar</span>
          </v-tooltip>
        </v-app-bar>
        <v-main>
          <v-container grid-list-sm>
            <v-slide-x-transition mode="out-in">
              <router-view :key="$route.fullPath"></router-view>
            </v-slide-x-transition>
          </v-container>
        </v-main>
        <v-progress-linear :active="appIsLoading" class="bottom-loader" indeterminate></v-progress-linear>
      </div>
      <v-snackbar
          v-model="snackbar.active"
          :color="snackbar.color"
          data-cy="globalSnackbar"
          :timeout="snackbar.timeout"
      >
        <p>
          <span v-if="snackbar.title" class="font-weight-bold">{{ snackbar.title }} <br></span>
          {{ snackbar.text }}
        </p>
        <template v-slot:action>
          <v-btn
              dark
              text
              @click="closeSnackbar"
          >
            Stäng
          </v-btn>
          <v-btn
              v-if="snackbar.actionClick"
              dark
              text
              @click="snackbarActionClick"
          >
            {{ snackbar.btnText }}
          </v-btn>
          <v-btn
              v-else-if="snackbar.url"
              :href="snackbar.url"
              dark
              text
          >
            {{ snackbar.btnText }}
          </v-btn>
        </template>
      </v-snackbar>
      <v-dialog v-model="dialog.active" max-width="550" persistent>
        <v-card>
          <v-card-title class="headline secondary--text">{{ dialog.title }}</v-card-title>
          <v-card-text>
            {{ dialog.text }}
            <v-alert v-if="dialog && dialog.alert" :color="dialog.alert.color" :type="dialog.alert.type" class="mt-6"
                     dense
                     outlined>
              {{ dialog.alert.text }}
            </v-alert>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn data-cy="globalDialogCancelBtn" class="left" text @click="closeDialog">{{
                dialog.closeBtnText
              }}
            </v-btn>
            <v-btn data-cy="globalDialogActionBtn" color="primary" text @click="dialogActionClick">
              {{ dialog.actionBtnText }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <!-- Uthyrd fancy loader while we check if user is logged in -->
    <uthyrd-loader-component v-else loadingText="Laddar in Uthyrd..."></uthyrd-loader-component>
  </v-slide-x-transition>
</template>

<script>
import LogoComponent from "./LogoComponent";
import api from "../../api/api";
import InitialsAvatarComponent from "@/components/global/InitialsAvatarComponent";
import UthyrdLoaderComponent from "./UthyrdLoaderComponent";
import websocket from "../../websocket/websocket";
import SetupGuideView from "../../views/setupguide/SetupGuideView";
import TourComponent from "../tour/TourComponent";
import SupportMenuComponent from "../support/SupportMenuComponent";
import GlobalSearchComponent from "../search/GlobalSearchComponent";
import accountSubscriptionTypes from "@/models/accountSubscriptionTypes";
import AccountSubscriptionExpiredComponent
  from "@/components/useraccount/accountsubscription/AccountSubscriptionExpiredComponent";

export default {
  name: 'AppComponent',
  components: {
    AccountSubscriptionExpiredComponent,
    GlobalSearchComponent,
    SupportMenuComponent, TourComponent, SetupGuideView, UthyrdLoaderComponent, LogoComponent, InitialsAvatarComponent
  },
  data: () => ({
    drawer: true,
    socket: null,
    currentTour: null,
  }),
  computed: {
    user() {
      return this.$store.state.user
    },
    isFirstSetupDone() // make sure user has a valid applicationEmailAddress
    {
      return this.user && this.user.applicationEmailAddress && this.user.applicationEmailAddress.length > 0 && this.user.applicationEmailAddress.indexOf("@") > 0
    },
    navItems() {
      return [
        {
          icon: 'mdi-home-outline', text: 'Hem', to: {name: 'home'}, dataCy: 'navHome'
        },
        {
          icon: 'mdi-calendar-outline', text: 'Uthyrningsperioder', to: {name: 'bookingPeriods'}, dataCy: 'navPeriods'
        },
        this.messagesNavItem,
        {
          icon: 'mdi-account-card-details-outline', text: 'Kunder', to: {name: "customers"}, dataCy: 'navCustomers'
        },
        {
          icon: 'mdi-home-city-outline',
          text: 'Uthyrningsobjekt',
          to: {name: 'bookingObjects'},
          dataCy: 'navBookingObjects'
        },
      ]
    },
    messagesNavItem() {
      return {
        icon: this.unreadMessages > 0 ? null : 'mdi-message-text-outline',
        badge: this.unreadMessages > 0 ? {text: this.unreadMessages, color: 'error'} : null,
        text: 'Meddelanden',
        to: {name: "messages"},
        dataCy: 'navMessages'
      }
    },
    unreadMessages() {
      return this.$store.state.unreadMessages
    },
    userAvatar() {
      if (this.$store.state.user.fileData && this.$store.state.user.fileData.src) {
        return api.BASE_URL + this.$store.state.user.fileData.src
      }
      return ""
    },
    appIsLoading() {
      return this.$store.state.appIsLoading
    },
    snackbar() {
      return this.$store.state.snackbar
    },
    dialog() {
      return this.$store.state.dialog
    },
    currentRoute() {
      return this.$store.state.currentRoute
    },
    editTour() {
      return this.$store.state.editTour
    },
    showTourBtn() {
      return this.currentTour && this.currentTour.id && this.currentTour.id >= 0
    },
    logoSize() {
      return this.$vuetify.breakpoint.smAndDown ? "32px" : "38px"
    },
    subscriptionName() {
      if (this.user && this.user.accountSubscription) {
        return accountSubscriptionTypes.TYPES[this.user.accountSubscription.type].name
      }
      return null
    }
  },
  props: {},
  async mounted() {
    this.drawer = this.$vuetify.breakpoint.lgAndUp // disables navdrawer showing up on tablets and mobile devices
    let authResponse = await api.getFromEndpoint(api.ENDPOINTS.AUTH)
    if (authResponse) {
      this.$store.commit('updateUser', authResponse)
      window.FreshworksWidget('identify', 'ticketForm', {
        name: `${authResponse.firstname} ${authResponse.lastname}`,
        email: authResponse.email,
      });
      let accountSubscription = await api.getFromEndpoint(api.ENDPOINTS.USERACCOUNTS + "/" + this.user.id + "/" + api.ENDPOINTS.ACCOUNTSUBSCRIPTION)
      if (accountSubscription) {
        authResponse.accountSubscription = accountSubscription
        this.$store.commit('setAppIsLoading', false)
        this.$store.commit('updateUser', authResponse)
      }
    }
    this.$nextTick(() => {

      // Headway widget for changelogs
      var HW_config = {
        selector: "#headwayChangelog", // CSS selector where to inject the badge
        account: "72BBZ7",
        translations: {
          title: "Nyheter & uppdateringar",
          readMore: "Läs vidare",
          footer: "Läs vidare"
        }
      }

      this.$store.dispatch('updateUnreadMessages', this.user)

      websocket.initiateWebSocketConnection()

      // Headway needs timeout to properly init
      window.setTimeout(() =>
          // eslint-disable-next-line
          Headway.init(HW_config), 1500)
    })
  },
  watch: {
    $route: {
      async handler(to) {
        // react to route changes...
        if (!this.$store.state.tours || this.$store.state.tours.length <= 0) {
          await this.getTours()
        }
        this.$store.commit('setCurrentRoute', to.name)

        let tour = this.$store.state.tours.find(tour => tour.routeName === this.currentRoute)
        if (tour && tour.id) {
          this.currentTour = tour
        } else {
          this.currentTour = null
        }
      },
      immediate: true
    },
  },
  methods: {
    async logoutUser() {
      this.$store.commit('setAppIsLoading', true)
      this.$store.commit('updateUser', null)
      await api.deleteReqToEndpoint(api.ENDPOINTS.AUTH)
      location.href = "/"
    },
    snackbarActionClick() {
      this.snackbar.actionClick()
      this.closeSnackbar()
    },
    closeSnackbar() {
      this.$store.commit('setSnackbar', {active: false})
    },
    closeDialog() {
      this.$store.commit('setDialog', {active: false})
    },
    dialogActionClick() {
      this.dialog.actionClick()
      this.closeDialog()
    },
    async getTours() {
      let tourResponse = await api.getFromEndpoint(api.ENDPOINTS.TOURS)
      if (tourResponse) {
        this.$store.commit('setTours', tourResponse)
      }
    },
    startTour() {
      if (!this.editTour) {
        this.$tours['walkthroughTour'].start()
      }
    }
  }
}
</script>

<style>

.navdrawer-background {
  position: fixed !important;
}

nav.navdrawer-background.v-navigation-drawer.v-navigation-drawer--absolute.v-navigation-drawer--clipped.v-navigation-drawer--is-mobile.v-navigation-drawer--open.theme--light {
  z-index: 6;
}

.navdrawer-background .v-navigation-drawer__image {
  background-size: cover;
  background-position: 50%;
  opacity: 0.08;
  min-height: 1400px;
}

.bottom-loader {
  position: absolute;
  bottom: 10px;
  margin: 0;
}

#HW_badge {
  height: 20px !important;
  width: 20px !important;
  line-height: 20px !important;
  font-size: 15px !important;
  top: 6px !important;
  left: 8px !important;
}

.v-card__title {
  padding: 16px 16px 16px !important;
}

.clickable {
  cursor: pointer;
}

.clickable-table tr {
  cursor: pointer;
}

.clickable textarea {
  cursor: pointer;
}

.clickable input {
  cursor: pointer;
}

.avatar td {
  padding: 0 !important;
  height: 36px !important;
  font-size: 17px !important;
}

.v-data-table-header-mobile__wrapper {
  min-width: 80px;
}

.force-on-top {
  z-index: 100 !important;
}

.remove-padding .v-speed-dial__list {
  padding: 0;
}

.dimmed-image img {
  filter: brightness(75%);
}

.v-tour__target--highlighted {
  box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.25) !important;
}

.scrollable {
  overflow-y: auto;
}

.avatar-outline {
  border: 1px solid #8380b6;
  border-radius: 50%;
}

.v-step__header {
  background-color: #897fa5 !important;
  color: white;
}

.v-step__content {
  font-size: 0.85rem;
}

.v-toolbar__title {
  text-overflow: unset;
}

.v-application p {
  margin-bottom: 6px;
}

.v-step__button {
  background: #897fa5 !important;
  border: .05rem solid #7f749c !important;
  color: #fff !important;
}

.v-step__button:hover {
  background: transparent !important;
  border: .05rem solid #7f749c !important;
  color: #897fa5 !important;
}

.outlined {
  border: 1px solid #dad8d8;
}

</style>
